import type { CSSProperties, ReactElement, ReactNode } from "react";
import { space, type SpaceKey } from "@ux/tokens";

export interface StackProps {
    readonly direction?: "row" | "column";
    readonly gap?: SpaceKey;
    readonly align?: CSSProperties["alignItems"];
    readonly justify?: CSSProperties["justifyContent"];
    readonly wrap?: boolean;
    readonly grow?: boolean;
    readonly style?: CSSProperties;
    readonly children?: ReactNode;
}

export function Stack({
    direction = "column",
    gap = 3,
    align,
    justify,
    wrap = false,
    grow = false,
    style,
    children,
}: StackProps): ReactElement {
    const composed: CSSProperties = {
        display: "flex",
        flexDirection: direction,
        gap: space[gap],
        flexWrap: wrap ? "wrap" : "nowrap",
        flex: grow ? 1 : undefined,
        minHeight: 0,
        minWidth: 0,
        ...(align !== undefined ? { alignItems: align } : {}),
        ...(justify !== undefined ? { justifyContent: justify } : {}),
        ...style,
    };
    return <div style={composed}>{children}</div>;
}
